/// <reference path="./typings/types.d.ts" />

import * as React from 'react';
import { classList,kanaConverter, RegExpEscape,toENEn } from './functions';

/**
 * クラス
 */
export class DataList extends React.Component<DataListProps, {}> {

	constructor(props : DataListProps) {
		super(props);
	}

	// アイテムのホバー状態のステータス切り替え
	changeOverState(flag : boolean) {
		this.props.changeOverState(flag);
	}

	// 選択した項目を入力欄に代入
	setValue(value : string) {
		this.props.setValue(value);
		this.props.resetState();
	}

	// レンダリング
	render() {
		const items      = this.props.items;
		const totalItems = items.length;
		const max        = (this.props.max > 0 && totalItems >= this.props.max) ? this.props.max : totalItems;
		const supItems   = items.slice(0, max); // suppressed items

		// リスト作成
		const listItems = supItems.map((data, i) => {
			if (this.props.selectItem === i) this.props.setSelectValue(data.text);

			return (i <= max) && <ListItem
				key           = { data.key }
				text          = { data.text }
				highlightText = { this.props.inputValue }
				select        = { this.props.selectItem === i }
				onClick       = { (value) => {
					this.props.inputFocus();
					this.props.setInputValue(value);
					this.setValue(value);
					this.props.inputChange();
					this.props.resetState();
					} }
				/>
		});

		const className = classList('datalist', !totalItems && 'hide');

		return (
			<div className={ className }>
				<ul
					id          = { this.props.id }
					role        = { 'listbox' }
					onMouseOver = { () => this.changeOverState(true) }
					onMouseOut  = { () => this.changeOverState(false) }
					>{ listItems }</ul>
			</div>
		);
	}
}

/**
 * アイテムクラス
 */
class ListItem extends React.Component<ListItemProps, {}> {

	private listItem : HTMLLIElement

	constructor(props : ListItemProps) {
		super(props);
	}

	// クリック時
	onClick(e : React.MouseEvent<HTMLLIElement>) {
		this.props.onClick(this.listItem.textContent);
	}

	// レンダリング
	render() {
		const className = classList('list-item', this.props.select && 'select');
		let text;

		if (this.props.highlightText) {
			// ハイライトするテキストの処理
			let highlightText = this.props.highlightText;
			let textRegExp = new RegExp("(?!%%%)(" + RegExpEscape(highlightText) + ")(?!%%%)", 'ig');
			let repText = this.props.text.replace(textRegExp, (matchStr, p1, offset, str) => {
				return '%%%' + matchStr + '%%%';
			});

			highlightText = toENEn(highlightText);

			textRegExp = new RegExp("(?!%%%)(" + RegExpEscape(highlightText) + ")(?!%%%)", 'ig');
			repText = repText.replace(textRegExp, (matchStr, p1, offset, str) => {
				return '%%%' + matchStr + '%%%';
			});

			highlightText = kanaConverter.convertKanaToTwoByte(highlightText);
			textRegExp = new RegExp("(?!%%%)(" + RegExpEscape(highlightText) + ")(?!%%%)", 'ig');
			repText = repText.replace(textRegExp, (matchStr, p1, offset, str) => {
				return '%%%' + matchStr + '%%%';
			});

			repText = repText.replace(/%%%(.*?)%%%/ig, '<b class="highlight">$1</b>');

			text = <span dangerouslySetInnerHTML = { { __html : repText } } />;
		} else {
			text = this.props.text;
		}

		return (
			<li
				ref           = { (item:any) => this.listItem = item }
				className     = { className }
				role          = { 'option' }
				aria-selected = { (this.props.select) ? true : false }
				onClick       = { (e:any) => { this.onClick(e); }}
				>{ text }</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/auto-suggest/src/datalist.tsx